// extracted by mini-css-extract-plugin
export var change = "_3w-1";
export var changeList = "_3w-0";
export var changePath = "_3w-2";
export var diffArrow = "_3w-5";
export var diffRow = "_3w-3";
export var diffValue = "_3w-4";
export var error = "_3w-8";
export var notice = "_3w-9";
export var result = "_3w-6";
export var success = "_3w-7";